const state = {
  chatMessages: [],
};

const mutations = {
  setChatMessages(state, { chatMessages = [] }) { state.chatMessages = chatMessages; },
  addChatMessage(state, { chatMessage }) {
    if (chatMessage != null && chatMessage.message != null && chatMessage.message !== '') {
      state.chatMessages.push(chatMessage);
    }
  },
};

const actions = {
  chat({ dispatch }, message) {
    dispatch('sendChatMessage', message);
  },
};

const getters = {
  chatMessages({ chatMessages = [] }) { return chatMessages; },
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/game/chat.js